import { graphql } from "gatsby"
import reducePageContent from "@utils/reducePageContent"
import VideoWithTimeline from "@components/VideoWithTimeline"

const NavigatingWithSuccesss = ({ data }) => {
  const pageContent = reducePageContent(data.page)
  const page = {
    pageContent: pageContent,
    heroID: "30aPmRlEfnfDxdTsV8NxKA",
    titleID: "7yQBZ7isnGK7WviXTUm4Dp",
    titlesID: "48aTEZi9VfwNA9HgXrB0TH",
    timestampsID: "7fmywVDLdEHylYic4ogHn0",
    videoID: "1JEXzvP2qVAratqrZQ2mJ6",
  }

  return <VideoWithTimeline content={page} />
}

export default NavigatingWithSuccesss

export const query = graphql`
  query ($contentful_id: String!) {
    page: contentfulPage(contentful_id: { eq: $contentful_id }) {
      ...Page
    }
  }
`

export { Head } from "@components/Head/Head"
